var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuisine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_403",
    "data-name": "Group 403",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.479,
    height: 27.639,
    viewBox: "0 0 26.479 27.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 26.479,
    height: 27.639,
    fill: "#bf772f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M12.176,9.029a7.422,7.422,0,0,1,2.4,1.69c-3.176,3.147-5.159,8.634-.108,7.611-.155.651,3.192,2.294,5.733-1.364.031-.031-4.168,2.341-5.283.62-5.609,1.054-1.441-5.456.6-6.8a14.3,14.3,0,0,1,3.92-1.132c-.031-1.4,1.116-7.533,4.121-8.03a2.316,2.316,0,0,0-1.642.2c-.713-.279-.2-1.845.7-1.473.217-.419,1.224-.512,1.394.015.7-.015,1.023.341,1.023.6a1.438,1.438,0,0,1,.2,1.473c-.2.341.17.76.17.76l1.053.713-1.177.419s.449,1.38-.6,1.767a1.063,1.063,0,0,1-1.425-.682c.031.512.511,1.178.976,1.162,6.027,8.448-1.348,13.114-7.049,16.183a3.215,3.215,0,0,1-1.069,1.643l.449,1.581,1.766-.062c.744-.031,1.147-.295,1.007.031s-1.193.651-1.844.527c.558.388,1.1.853.961,1.116-.124.263-1.611-.853-1.828-1.023-.62.186-1.689.387-1.844.016-.139-.388.232-.217.682-.2a1.015,1.015,0,0,0,.728-.341l-.6-1.628a2.655,2.655,0,0,1-1.24-2.015c-1.921-.6-3.439-.667-4.973-2.2-.62.729-2.2.062-1.844-2.217-1.611,1.4-2.293-.775-2.216-2.263-.945.852-2.076.155-2.355-2.5-1.751.791-1.937-1.364-1.518-2.961-1.6.434-2.8-3.085,1.72-4.805C7.683,3.759,11.4,7.417,12.176,9.029",
    transform: "translate(0 -0.001)",
    fill: "#bf772f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuisine);
export default __webpack_public_path__ + "static/media/cuisine.deb0177fdd04964071be74f9ec0b2c5f.svg";
export { ForwardRef as ReactComponent };